import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import useStore from 'reusable/mobx-store-utils'
import { useMainContainerStore } from 'features/main/main-router/org-guard/main-container/MainContainerStore'
import Typography from '@mui/material/Typography'
import VgcSelectClientModalStore from './VgcSelectClientModalStore'
import CreateClientAutocomplete from 'features/clients/create/CreateClientAutocomplete'
import { useCacheStore } from 'cache/CacheStore'
import { themeConfig } from '@gap/shared/theme'
import GapUnderlineLink from 'features/gap-components/link/GapUnderlineLink'
import GapMath from '/images/The_Gap_Math.svg'
import { htmlSpace } from 'reusable/utils/utils'

export interface VgcSelectClientModalProps {
   source?: 'getting-started-checklist' | 'main-menu'
}

export default observer(function VgcSelectClientModal(props: VgcSelectClientModalProps) {
   const mainContainerStore = useMainContainerStore()
   const cacheStore = useCacheStore()
   const vgcSelectClientModalStore = useStore(sp => new VgcSelectClientModalStore(sp), { mainContainerStore, cacheStore, source: props.source })

   return <Box display="flex">
      <Box>
         <Typography variant="h3" sx={{ mb: 3, color: themeConfig.primary[900] }}>Easily identify profit and cashflow improvement opportunities</Typography>

         <Typography variant="body1" sx={{ color: themeConfig.primary[900], mb: 6 }}>
            The Value Gap Calculator allows you to show clients how small changes to their sales, cashflow or profit can transform their business.
         </Typography>

         {vgcSelectClientModalStore.formHandler.selectedClientId.bindInput(ip =>
            <CreateClientAutocomplete
               {...ip}
               label="Choose a client"
               onChange={vgcSelectClientModalStore.onClientSelectedHandler}
            />
         )}

         <Box sx={{ mt: 6 }}>
            <Button variant="contained" disabled={!vgcSelectClientModalStore.fields.selectedClientId} onClick={vgcSelectClientModalStore.openCalculator} sx={{ width: '100%' }}>Open calculator</Button>
         </Box>

         <Box sx={{ mt: 2, color: themeConfig.primary[800] }}>
            <Typography variant="body2" display="inline" fontSize="700">Need some help?{htmlSpace}</Typography>
            <GapUnderlineLink href='https://help.thegaphq.com/portal/en/kb/articles/value'>Learn more</GapUnderlineLink>
            <Typography variant="body2" display="inline" fontSize="700">{htmlSpace}about using the <Box component="span" sx={{ whiteSpace: 'nowrap' }}>Value Gap Calculator</Box> or{htmlSpace}</Typography>
            <GapUnderlineLink href='https://www.thegaphq.com/contact-us'>talk to us!</GapUnderlineLink>
         </Box>
      </Box>

      <Box sx={{ flex: 1 }}>
         <img src={GapMath} width="322" height="322" alt="The Gap Math Logo" />
      </Box>
   </Box>
})
